
import React from 'react'

import {Link } from 'react-router-dom';


const Footer = () => {
// need to  which out react icon to  only fontawesome 
// npm uninstall <name>
// updated link and added background color white to make it more visible

  return (
    <footer className=" flex items-center flex-col bg-[#221573] text-white py-8  mt-8">
                    <span className=" flex items-center gap-1 cursor-pointer" onClick={()=>{ window.scrollTo({ top:0 , behavior: 'smooth'})}}>Top <i class="fa-solid fa-arrow-up"></i></span>
                <div className=" flex gap-2 my-2 flex-col md:flex-row">
                   <Link className=" flex items-center gap-1" to='mailto:dante@safekeephomerepair.com' target='_blank'><i class="fa-solid fa-envelope"></i>: dante@safekeephomerepair.com</Link> 
                   <Link className="flex items-center gap-1" to='tel:216-210-4484'> <i class="fa-solid fa-phone"></i> : 216-210-4484</Link> 
                </div>
                <div className="">
Copyright &copy; 2024 Safekeep Home Repair
                </div>
                <div>
                  
                      <a href="https://www.bbb.org/us/oh/cleveland-heights/profile/handyman/safekeep-home-repair-llc-0312-92059470/#sealclick" target="_blank" rel="nofollow"><img src="https://seal-cleveland.bbb.org/seals/blue-seal-200-42-bbb-92059470.png" style={{ border: 0, backgroundColor:"white" }} alt="Safekeep Home Repair LLC BBB Business Review" /></a>

                </div>
           
        </footer>
  )
}

export default Footer

